import {Component, inject, Input, OnChanges} from '@angular/core';
import {AConst} from '../../core/a-const.enum';
import {RefService} from '../../core/ref.service';
import {SearchHandlerService} from '../../object-search/search-handler.service';
import {SuperObjectModel} from "../../core/definitions/super-object-model";
import {SearchContainer} from "../../core/definitions/search-container";
import {FeatureFlagsService} from '../../core/feature-flags.service';
import { ObjectPageNavigationStack } from '../../object-page-v2/object-page-navigation-stack';
import {StateParams} from "../../core/definitions/state-params";
import {RefParams} from "../../core/definitions/ref-params";
import {TooltipPosition} from "@angular/material/tooltip";

@Component({
    selector: 'app-object-url',
    templateUrl: './object-url.component.html',
    styleUrls: ['./object-url.component.scss'],
    standalone: false
})
export class ObjectUrlComponent implements OnChanges {
  // Injections
  private readonly featureFlagService: FeatureFlagsService = inject(FeatureFlagsService);
  private readonly objectPageNavigationStack: ObjectPageNavigationStack = inject(ObjectPageNavigationStack);
  private readonly ref: RefService = inject(RefService);
  private readonly searchHandler: SearchHandlerService = inject(SearchHandlerService);

  AConst = AConst;
  @Input() currentObjectName: string;
  @Input() object: SuperObjectModel;
  @Input() searchItemIndex: number;
  @Input() rootObjId: string;
  @Input() rootObjType: string;
  @Input() searchContainer: SearchContainer;
  @Input() disable: boolean;
  @Input() listName: string;
  @Input() hasImage: boolean;
  @Input() useUrl: boolean;
  @Input() aClass: string;
  @Input() openLinksInTab: boolean;
  @Input() tooltip: string;
  @Input() tooltipPosition: TooltipPosition = 'below';
  @Input() tooltipPositionAtOrigin = false;

  isDisabled: boolean;
  uiOptions = {
    reload: true
  };
  routerLink: any[];
  queryParams: any;
  externalLink: string;

  ngOnChanges() {
    this.getRef().then(() => {
      if (this.featureFlagService.getFeatureFlags().experimental.useNewObjectPage && this.object?.artifact_id) {
        if (this.routerLink.join('/').includes('/artifact')) {
          this.routerLink.push(this.object.artifact_id);
        }
      }
    });
    this.isDisabled = this.disable || !this.object;
    if (this.isDisabled) {
      this.uiOptions.reload = false;
    }
  }

  async getRef(): Promise<void> {
    if (this.object.artifact_id) {
      const params = new RefParams(this.object, {
        listName: null
      } as StateParams);
      params.searchItemIndex = null;
      params.rootObjId = null;
      if (this.searchItemIndex !== undefined) {
        params.searchItemIndex = this.searchItemIndex;
      }
      if (this.rootObjId !== undefined) {
        params.rootObjId = this.rootObjId;
        params.rootObjType = this.rootObjType;
      }
      if (this.listName) {
        params.stateParams.listName = this.listName;
      }
      const refData = await this.ref.makeRef(params);
      if (refData?.param.externalLink) {
        this.externalLink = refData.param.externalLink;
      } else if (refData) {
        this.externalLink = refData.param.externalLink;
        this.routerLink = refData.routerLink;
        if (refData.stateName === 'user-profile' && refData.param.hasOwnProperty('userId')) {
          this.routerLink.push(refData.param.userId);
        }
        this.queryParams = refData.queryParams;
        // Delete parentId
        delete this.queryParams.parentId;
        this.isDisabled = this.isDisabled || refData.disabled;
      } else {
        this.isDisabled = true;
      }
    }
  }

  clickExternalItem(href: string) {
    window.open(href, '_blank', 'noopener, noreferrer');
  }

  clickItem() {
    if (this.featureFlagService.getFeatureFlags()?.experimental.useNewObjectPage && this.currentObjectName) {
      this.objectPageNavigationStack.addArtifactToHistory(this.currentObjectName, location.pathname, this.queryParams);
    }

    if (this.searchContainer && this.searchItemIndex !== undefined) {
      this.searchHandler.setSearchItemIndex(this.searchContainer, this.searchItemIndex);
    }
  }
}
